import React from 'react';
import type { FC } from 'react';
import { Alert, Badge, Text, Box, Link } from '@wix/cli-ui-kit';
import { Trans } from '@wix/cli-i18n';

export const McpConfigCreated: FC<{ mcpPath: string; docsUrl: string }> = ({
  mcpPath,
  docsUrl,
}) => {
  return (
    <Box flexDirection="column" marginBottom={1}>
      <Box marginLeft={-2}>
        <Alert type="success">
          <Badge skin="success">
            <Trans i18nKey="create_app.mcp_config_created_badge" />
          </Badge>{' '}
        </Alert>
      </Box>
      <Box marginTop={1} flexDirection="column">
        <Text>
          <Trans
            i18nKey="create_app.mcp_config_created_1"
            components={[<Text bold />]}
            values={{ mcpPath }}
          />
        </Text>
        <Text>
          <Trans i18nKey="create_app.mcp_config_created_2" />
        </Text>
        <Text>
          <Trans
            i18nKey="create_app.mcp_config_created_3"
            components={[<Link skin="info" url={docsUrl} />]}
          />
        </Text>
      </Box>
    </Box>
  );
};
